<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs4>
                <v-text-field label="申请号/登记号" clearable required :rules="rules.number" v-model="item.number"/>
              </v-flex>
              <v-flex xs4>
                <v-menu
                  ref="appDateMenuRef"
                  lazy
                  :close-on-content-click="false"
                  v-model="appDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                  :return-value.sync="item.appDate"
                >
                  <v-text-field
                    slot="activator"
                    label="申请日期"
                    required
                    :rules="rules.required"
                    v-model="item.appDate"
                    clearable
                    readonly
                  />
                  <v-date-picker
                    v-model="item.appDate"
                    locale="zh-cn"
                    type="date">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="appDateMenu=false">取消</v-btn>
                    <v-btn flat color="primary" @click="$refs.appDateMenuRef.save(item.appDate)">确认</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  label="代理人员"
                  clearable
                  :rules="rules.required"
                  v-model="item.agentId"
                  item-text="name"
                  item-value="dbid"
                  :items="agentItems"
                />
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  label="流程状态"
                  clearable
                  :rules="rules.required"
                  v-model="item.processStateId"
                  item-text="name"
                  item-value="dbid"
                  :items="processStateItems"
                />
              </v-flex>
              <v-flex xs4>
                <v-menu
                  ref="processStateDateMenuRef"
                  lazy
                  :close-on-content-click="false"
                  v-model="processStateDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                  :return-value.sync="item.processStateDate"
                >
                  <v-text-field
                    slot="activator"
                    label="流程状态日期"
                    required
                    :rules="rules.required"
                    v-model="item.processStateDate"
                    clearable
                    readonly
                  />
                  <v-date-picker
                    v-model="item.processStateDate"
                    locale="zh-cn"
                    type="date">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="processStateDateMenu=false">取消</v-btn>
                    <v-btn flat color="primary" @click="$refs.processStateDateMenuRef.save(item.processStateDate)">确认</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="备注" clearable v-model="item.notes"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'
  import XUserSelectForm from '@/components/global/UserSelectForm'
  const  baseUri= '/api/inte/intellectualApp/manage';
  const agentUri= '/api/inte/agent';
  const pstateUri= '/api/inte/processState/';
  export default {
    mixins: [mixin.edit(baseUri)],

    components: {XUserSelectForm},
    data() {
      return {
        formValid: false,
        item: {},
        freshItem: {
          "name": "",
          "typeId":"",
          "type": "",
          "affiliation": "",
          "departmentId": "",
          "department": "",
          "agencyId": "",
          "agency": "",
          "source": "",
          "contractId":"",
          "submitDate": "",
          "status": "",
          "outcomeState": "",
          "apps": [],
          "orgs": [],
          "agentId": "",
          "agent": "",
          "managerId": "",
          "manager": "",
          "processStateId": "",
          "processState": "",
          "outcomeStateId": "",
          "processStateDate": "",
          "number": "",
          "notes":"",
          "attachments": []
        },
        appDateMenu: false,
        processStateDateMenu: false,
        agentItems: [],
        processStateItems: [],

        /**
         * 验证规则
         */
        rules: {
          required:[v => !!v || '必填项。'],
          number: [
            v => !!v || '必填项。',
            v => (v && v.length <= 15) || '长度必须小于15个字符。'
          ]
        }
      }
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(agentUri, {params: {limit: 65535, disabled: 'F',sort: 'order.asc'}}),
        this.axios.get(pstateUri, {params: {sort: 'order.asc'}})
      ]).then(
        this.axios.spread(
          (rspAgent,rspPstate) => {
            this.agentItems = rspAgent.data.items;
            this.processStateItems = rspPstate.data.items;
          }
        )
      )
    },

    watch: {

    },

    computed: {

    },

    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {

      },
    }
  }
</script>
